import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'vr-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class EnterpriseComponent implements OnInit {
  isLoading = false;
  tokenError: string = null;

  loginForm: FormGroup;
  token = new FormControl('', Validators.required);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.loginForm = new FormGroup({ token: this.token });
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.token.setValue(token);
      this.submitForm();
    }
  }

  submitForm() {
    this.tokenError = null;
    this.isLoading = true;
    this.http
      .post(environment.API_PATH + 'auth/loginenterprise', { token: this.token.value }, { withCredentials: true })
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          if (response && response.session) {
            this.router.navigate(['/actions/plans']);
          } else {
            this.tokenError = 'Accès refusé.';
            this.changeDetectorRefs.detectChanges();
          }
        },
        (err) => {
          this.isLoading = false;
          const errBody = err && err.error ? err.error : {};
          const code = errBody.code || errBody.message;
          if (code === 'TOKEN_INVALID') {
            this.tokenError = 'Token invalide ou entreprise introuvable.';
          } else if (code === 'TOKEN_REQUIRED') {
            this.tokenError = 'Token manquant.';
          } else {
            this.tokenError = 'Une erreur est survenue, veuillez réessayer.';
          }
          this.changeDetectorRefs.detectChanges();
        }
      );
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/enterprise/enterprise.component.ts